export default __webpack_public_path__ + "static/media/guaranteeIcon2.5a2d3da3.png";